import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import stateButton from '@/components/export-history/state-button/state-button.vue';
import datepicker from 'vuejs-datepicker';

const DATE_FORMAT = 'MM/DD/YYYY';
const DATE_FORMAT_API = 'MM-DD-YYYY';
const KIND_TRADE = 'trade';
const KIND_TRANSACTION = 'transaction';

function dateFormatter(date) {
  return moment(date).format(DATE_FORMAT);
}

export default {
  components: {
    stateButton,
    datepicker,
  },
  props: {
    kind: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dateFormatter,
      disabled: {
        from: null,
      },
      selected: {
        l30d: false,
        l3m: false,
        ytd: false,
      },
      dates: {},
      dateFrom: {
        date: null,
      },
      dateTo: {
        date: null,
      },
      openCalendar: false,
    };
  },
  computed: {
    ...mapState('market', ['market']),
    ...mapState('overlay', ['visible']),
    ...mapState('user', ['token']),
    formAction() {
      switch (this.kind) {
        case KIND_TRANSACTION:
          return process.env.TRANSACTION_CSV_DOWNLOAD_URL;
        case KIND_TRADE:
          return process.env.TRADE_CSV_DOWNLOAD_URL;
        default:
          return '';
      }
    },
    marketId() {
      if (this.$route.params.marketId && this.$route.params.marketId !== 'all') {
        return this.$route.params.marketId;
      }
      return null;
    },
    contractId() {
      if (this.$route.query) {
        return this.$route.query.contractId;
      }
      return null;
    },
    contractName() {
      if (this.contractId) {
        const contract = this.market.contracts.find(i => i.contractId === this.contractId);
        return (contract || {}).contractName;
      }
      return null;
    },
  },
  watch: {
    'dateFrom.date': 'watchDateChange',
    'dateTo.date': 'watchDateChange',
    visible() {
      if (!this.openCalendar && !this.visible) {
        this.setCurrentPopup();
      }
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('overlay', {
      hideOverlay: 'hide',
      showOverlay: 'show',
    }),
    watchDateChange() {
      const preset = this.isPreset(
        moment(this.dateFrom.date).format(DATE_FORMAT),
        moment(this.dateTo.date).format(DATE_FORMAT),
        this.dates,
      );
      this.setButton(preset);
    },
    onButtonClick(btn) {
      this.dateFrom = {
        date: new Date(Date.parse(this.dates[btn.name])),
      };
      this.dateTo = {
        date: new Date(Date.parse(this.dates.today)),
      };
    },
    onExport() {
      const StartDate = moment(this.dateFrom.date).format(DATE_FORMAT_API);
      const EndDate = moment(this.dateTo.date).format(DATE_FORMAT_API);

      this.$refs.StartDate.value = StartDate;
      this.$refs.EndDate.value = EndDate;
      // this.$refs.bearer.value = this.token; because API wants this as get
      this.$refs.staticForm.action = `${this.formAction}?bearer=${this.token}`;
      this.$refs.staticForm.submit();
      this.setCurrentPopup();
      this.hideOverlay();
    },
    setButton(btn) {
      Object.keys(this.selected).forEach((a) => {
        this.selected[a] = btn === a;
      });
    },
    setAllDates() {
      const dates = this.dates;
      const now = new Date();
      dates.today = moment(now).format(DATE_FORMAT);
      dates.l30d = moment(now).subtract(30, 'days').format(DATE_FORMAT);
      dates.l3m = moment(now).subtract(3, 'months').format(DATE_FORMAT);
      dates.ytd = moment(now).subtract(1, 'years').format(DATE_FORMAT);
    },
    isPreset(start, end, dates) {
      if (end !== dates.today) {
        return false;
      }
      switch (start) {
        case dates.l30d:
          return 'l30d';
        case dates.l3m:
          return 'l3m';
        case dates.ytd:
          return 'ytd';
        default:
      }
      return false;
    },
    opened() {
      // show component overlay
      this.openCalendar = true;
      // hide app overlay
      this.hideOverlay();
    },
    closed() {
      // hide component overlay
      this.openCalendar = false;
      // show app overlay
      this.showOverlay();
    },
    overlayClick() {
      // hide component overlay
      this.openCalendar = false;
    },
    fromClick() {
      // datepicker has no refs nor showMethod
      const input = this.$refs.fromDatepicker.$el.querySelector('input');
      input.click();
    },
    toClick() {
      // datepicker has no refs
      const input = this.$refs.toDatepicker.$el.querySelector('input');
      input.click();
    },
  },
  mounted() {
    this.setAllDates();
    this.onButtonClick({ name: 'ytd' });
    this.disabled.from = new Date();
  },
};



// WEBPACK FOOTER //
// ./src/components/export-history/export-history.js